import { render, staticRenderFns } from "./LiondeskContentEditor.vue?vue&type=template&id=09b62592&scoped=true&lang=pug"
import script from "./LiondeskContentEditor.vue?vue&type=script&lang=js"
export * from "./LiondeskContentEditor.vue?vue&type=script&lang=js"
import style0 from "./LiondeskContentEditor.vue?vue&type=style&index=0&id=09b62592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b62592",
  null
  
)

export default component.exports